export const getTheWordObj = (transcripts, time) => {
  const currentWords = findWordsByTime(time, transcripts, 0);

  if (currentWords?.words) {
    const { words, index } = currentWords;
    return findTranscriptByTime(time, words, index, 0);
  }
  return null;
};

const findWordsByTime = (time, data, index = 0) => {
  let left = index;
  let right = data.length - 1;

  while (left <= right) {
    let mid = Math.floor((left + right) / 2);
    let arr = data[mid];

    const startTime = arr.words[0].start_timestamp;
    const endTime = arr.words[arr.words.length - 1].end_timestamp;

    if (time >= startTime && time <= endTime) {
      return { ...arr, index: mid };
    } else if (time < startTime) {
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  return null;
};

const findTranscriptByTime = (time, data, wordsIndex, index = 0) => {
  let left = index;
  let right = data?.length - 1;

  while (left <= right) {
    let mid = Math.floor((left + right) / 2);
    let obj = data?.[mid];

    if (time >= obj.start_timestamp && time <= obj.end_timestamp) {
      return { ...obj, indexes: { sentence: '' + wordsIndex, word: '' + mid } };
    } else if (time < obj.start_timestamp) {
      right = mid - 1;
    } else {
      left = mid + 1;
    }
  }

  return null;
};
